import { cn } from '@/lib/utils/cn';
import type { Question } from '@/types';

interface QuestionWrapperProps {
  question: Question;
  errors?: string[];
  children: React.ReactNode;
  className?: string;
}

export function QuestionWrapper({
  question,
  errors,
  children,
  className,
}: QuestionWrapperProps) {
  const hasErrors = errors && errors.length > 0;
  const showQuestionNumber = question.config?.showQuestionNumber !== false;

  return (
    <div
      className={cn(
        'question-card',
        hasErrors && 'border-red-200 bg-red-50/30',
        className
      )}
    >
      {/* Question text */}
      <div className="mb-4">
        <h3 className="text-base font-medium text-gray-900">
          {showQuestionNumber && (
            <span className="text-gray-500 mr-2">{question.code}.</span>
          )}
          {question.text}
          {question.required && (
            <span className="ml-1 text-red-500" aria-label="required">
              *
            </span>
          )}
        </h3>

        {/* Help text */}
        {question.helpText && (
          <p className="mt-1 text-sm text-gray-500">{question.helpText}</p>
        )}
      </div>

      {/* Question content */}
      <div className="mt-4">{children}</div>

      {/* Validation errors */}
      {hasErrors && (
        <div className="mt-3" role="alert">
          {errors.map((error, index) => (
            <p key={index} className="text-sm text-red-600 flex items-center">
              <svg
                className="mr-1 h-4 w-4 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              {error}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
